import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    LimitReportReviewOverviewBaseComponent,
} from '@backoffice-frontend/limit-report/domain';
import { LimitStrategy } from '@clean-code/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';
import { DxTemplateModule, DxTooltipModule } from 'devextreme-angular';

@Component({
  selector: 'backoffice-frontend-limit-report-review-power-overview',
  templateUrl: './limit-report-review-overview.component.html',
  styleUrls: ['./limit-report-review-overview.component.scss'],
  imports: [
    CommonModule,
    MatProgressBarModule,
    TranslocoModule,
    FontAwesomeModule,
    MatTooltipModule,
    DxTooltipModule,
    DxTemplateModule,
  ],
})
export class LimitReportPowerReviewOverviewComponent extends LimitReportReviewOverviewBaseComponent {
  limitStrategyPassive = LimitStrategy.Passive;
  faInfoCircle = faInfoCircle;

  constructor() {
    super();
  }
}
